module.exports = __webpack_public_path__ + "static/media/taco-bell.bbe30fe1.svg";